"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const translate_1 = require("../helper/translate");
const SelectedFiltersSummary = ({ selectedFilters, filters }) => {
    const summaryString = Object.entries(selectedFilters).reduce((acc, [filterName, selectedIds], index, array) => {
        const filterData = filters[filterName];
        const filterTitle = (filterData === null || filterData === void 0 ? void 0 : filterData.title) || filterName;
        const selectedLabels = (filterData === null || filterData === void 0 ? void 0 : filterData.options.filter(option => selectedIds.includes(option.value)).map(option => option.label)) || [];
        acc += `<strong>${filterTitle}</strong>: ${selectedLabels.join(', ')}${index < array.length - 1 ? ', ' : ''}`;
        return acc;
    }, `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span>`);
    return ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: summaryString } }));
};
exports.default = SelectedFiltersSummary;
